module.exports = {"greenTemperature":"그린 온도","hourlyGreenTemperature":"시간별 그린 온도","periodGreenTemperature":"기간별 그린 온도","selectGolfClubPlaceholder":"골프클럽을 선택하세요.","selectTypePlaceholder":"유형을 선택하세요.","oneMonth":"1개월","threeMonths":"3개월","sixMonths":"6개월","total":"전체","countUnit":"건","date":"날짜","viewDetailOnPc":"기간별 그린 온도 상세 보기는 PC에서 확인하세요.","noData":"데이터가 없습니다."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/gr102.json
// module id = Q/c3
// module chunks = 2